<template>
  <div class="hab-top-filter">
    <div class="hab-top-filter__title">{{ $t('filter.tickets_booking') }}</div>
    <CompFlex align="center" className="top-filter">
      <div>
        <CompFlex align="center" gap="5" className="select-location">
          <multiselect
            v-model="formData.from"
            :options="cityList"
            :placeholder="get(formData, 'from.name', $t('filter.start'))"
            label="name_non_vi"
            :allow-empty="false"
            :hideSelected="true"
            selectLabel=""
            selectedLabel=""
            deselectLabel=""
          >
            <template slot="noOptions">{{ $t("filter.list_empty") }}</template>
            <template slot="noResult">{{ $t("filter.no_result") }}</template>
            <template slot="singleLabel" slot-scope="props">{{
              props.option.name
            }}</template>
            <template slot="option" slot-scope="props">{{
              props.option.name
            }}</template>
          </multiselect>
          <img :src="locationIcon" alt="location" style="width: 16px" />
        </CompFlex>
        <img
          :src="changeIcon"
          class="select-icon"
          alt="tu"
          v-on:click="switchLocation"
        />
        <span v-if="formDataError?.from" class="form-error">{{
          formDataError?.from
        }}</span>
      </div>
      <div>
        <CompFlex align="center" gap="5" className="select-location">
          <multiselect
            v-model="formData.to"
            :options="cityList"
            :placeholder="get(formData, 'to.name', $t('filter.end'))"
            label="name_non_vi"
            :allow-empty="false"
            :hideSelected="true"
            selectLabel=""
            selectedLabel=""
            deselectLabel=""
          >
            <template slot="noOptions">{{ $t("filter.list_empty") }}</template>
            <template slot="noResult">{{ $t("filter.no_result") }}</template>
            <template slot="singleLabel" slot-scope="props">{{
              props.option.name
            }}</template>
            <template slot="option" slot-scope="props">{{
              props.option.name
            }}</template>
          </multiselect>
          <img :src="locationIcon" alt="location" style="width: 16px" />
        </CompFlex>
        <span v-if="formDataError?.to" class="form-error">{{
          formDataError?.to
        }}</span>
      </div>
      <div>
        <CompDatepicker
          :placeholder="$t('filter.chon_ngay_di')"
          :theme="1"
          :value="get(formData, 'date', '')"
          @onChange="(value) => changeField('date', value)"
        />
        <span v-if="formDataError?.date" class="form-error">{{
          formDataError?.date
        }}</span>
      </div>
      <div>
        <CompButton
          :label="$t('filter.tim_ve')"
          :min="150"
          :theme="1"
          @onClick="onTicketSearch"
        />
      </div>
    </CompFlex>
  </div>
</template>

<script>
import {
  toConvertUrl,
  toConvertDateFromString,
  toLowerCaseNonAccentVietnamese,
} from "../../../utils/helpers";
import CompFlex from "../../flex/index.vue";
import CompDatepicker from "../../datepicker/index.vue";
import CompButton from "../../button/index.vue";
import { isEmpty, get } from "lodash";

export default {
  components: {
    CompFlex,
    CompDatepicker,
    CompButton,
  },
  data() {
    return {
      changeIcon: appUrl + "/public/images/icon/change.svg",
      locationIcon: appUrl + "/public/images/icon/location.svg",
      formDataError: null,
      formData: {
        from: null,
        to: null,
      },
    };
  },
  computed: {
    cityList() {
      if (isEmpty(this.$store.state.area.cityList)) {
        return [];
      }

      let results = [];
      const statesCities = this.$store.state.area.cityList.filter((item) => {
        return item.type === 3;
      });

      if (statesCities) {
        results = [
          {
            name: this.$t("filter.states_cities"),
            id: 0,
            $isDisabled: true,
          },
          ...statesCities,
        ];
      }

      let districts = this.$store.state.area.cityList.filter((item) => {
        return item.type === 5;
      });

      districts = districts.map((d) => {
        if (d?.base_id) {
          const parent = statesCities.find((s) => {
            return s?.id === d?.base_id;
          });
          if (parent) {
            d.name += " - " + parent.name;
          }
        }

        return d;
      });

      if (districts) {
        results = [
          ...results,
          {
            name: this.$t("filter.districts"),
            id: 0,
            $isDisabled: true,
          },
          ...districts,
        ];
      }

      return results.map((e) => ({
        ...e,
        name_non_vi: e?.name + " | " + toLowerCaseNonAccentVietnamese(e?.name),
      }));
    },
  },
  mounted() {
    if (bookingDate) {
      const newDate = toConvertDateFromString(bookingDate);
      this.formData = {
        ...this.formData,
        date: newDate.isValid() ? newDate.toDate() : undefined,
      };
    }
  },
  watch: {
    cityList(data) {
      if (isEmpty(data)) {
        return;
      }
      if (bookingFrom) {
        const from = data.find((e) => e?.id == bookingFrom);
        this.formData = {
          ...this.formData,
          from: { ...from },
        };
      }
      if (bookingTo) {
        const to = data.find((e) => e?.id == bookingTo);
        this.formData = {
          ...this.formData,
          to: { ...to },
        };
      }
    },
  },
  methods: {
    get,
    changeField(name, value) {
      this.formData = {
        ...this.formData,
        [name]: value,
      };
    },
    onTicketSearch() {
      this.formDataError = null;
      if (!this.formData?.from || !this.formData?.to || !this.formData?.date) {
        let newError = null;
        if (!this.formData?.from) {
          newError = {
            ...newError,
            from: this.$t("common.vuilongchondulieu"),
          };
        }
        if (!this.formData?.to) {
          newError = {
            ...newError,
            to: this.$t("common.vuilongchondulieu"),
          };
        }
        if (!this.formData?.date) {
          newError = {
            ...newError,
            date: this.$t("common.vuilongchondulieu"),
          };
        }
        this.formDataError = newError;
        return;
      }

      let url = appUrl + "/bus-ticket-booking-from";
      if (this.$i18n.locale === "vn") {
        url = appUrl + "/vn/ve-xe-khach-tu";
      }
      const fromString = toConvertUrl(this.formData?.from?.name || "");
      const toString = toConvertUrl(this.formData?.to?.name || "");
      if (fromString && toString && this.formData?.date) {
        let toTrans = "to";
        if (this.$i18n.locale === "vn") {
          toTrans = "di";
        }
        const newRouter = `${url}-${fromString}-${toTrans}-${toString}-${
          this.formData?.from?.id
        }t${this.formData?.to?.id}.html?date=${moment(
          this.formData?.date
        ).format("YYYY-MM-DD")}`;
        console.log(newRouter)
        window.parent.postMessage({ url: newRouter }, '*')
        return window.location.href = newRouter;
      }
    },
    switchLocation() {
      this.formData = {
        ...this.formData,
        from: this.formData?.to,
        to: this.formData?.from,
      };
    },
  },
};
</script>
